var React = require('react');

function ExpandedInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#D9A867","fillRule":"nonzero","d":"M14.5 0C6.492 0 0 6.492 0 14.5S6.492 29 14.5 29 29 22.508 29 14.5 22.508 0 14.5 0zm0 2C21.404 2 27 7.596 27 14.5S21.404 27 14.5 27 2 21.404 2 14.5 7.596 2 14.5 2z","key":0}),React.createElement("path",{"stroke":"#D9A867","strokeLinecap":"round","strokeWidth":"2","d":"M7.5 14.5h14","key":1})]));
}

ExpandedInline.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29"};

module.exports = ExpandedInline;

ExpandedInline.default = ExpandedInline;
